export default "__VITE_ASSET__v4GXPXYc__"